import ComponentRegistry from "Fratello/Common/ComponentRegistry";

// Product Purchase
import ProductPurchaseWidget from "Fratello/ProductPurchase/Widgets/ProductPurchaseWidget";

import {createProductStore as ProductStore} from "Fratello/ProductPurchase/Stores/ProductStore";

import ProductPurchasAtomsPrice from "Fratello/ProductPurchase/Atoms/Price";
import ProductPurchaseAtomsProperty from "Fratello/ProductPurchase/Atoms/Property";

import ProductPurchaseViewsPurchaseView from "../ProductPurchase/Views/PurchaseView";
import ProductPurchaseViewsVariationView from "Fratello/ProductPurchase/Views/VariationView";
import ProductPurchaseViewsWishlistView from "Fratello/ProductPurchase/Views/WishlistView";
import ProductPurchaseViewsPricingView from "Fratello/ProductPurchase/Views/PricingView";
import ProductPurchaseViewsPersonalisationFormView from "Fratello/ProductPurchase/Views/PersonalisationFormView";

ComponentRegistry.registerStore({ProductStore});

ComponentRegistry.register({ProductPurchaseWidget});
ComponentRegistry.register({ProductPurchasAtomsPrice});
ComponentRegistry.register({ProductPurchaseAtomsProperty});
ComponentRegistry.register({ProductPurchaseViewsPricingView});
ComponentRegistry.register({ProductPurchaseViewsPersonalisationFormView});
ComponentRegistry.register({ProductPurchaseViewsPurchaseView});
ComponentRegistry.register({ProductPurchaseViewsVariationView});
ComponentRegistry.register({ProductPurchaseViewsWishlistView});



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Components/ProductPurchase.jsx